import { FC, Fragment } from 'react';
import cs from 'classnames';
import { isNotEmpty } from '@lhb/func';
import V2Tag, { V2TagProps } from '@/common/components/Data/V2Tag';
import { Tooltip } from 'antd';
import styles from './index.module.less';

interface TagProps extends V2TagProps {
  /** 标签图片，优先级：img > label */
  img?: string,
  imgWidth?: any,
  imgHeight?: any,
  /** 标签名称 */
  label?: string,
  /** tooltip 提示文本 */
  tip?: string
}

/**
 * 标签组
 * @description 标签数组组件，Tag 标签属性基于 <a href="https://reactpc.lanhanba.net/components/Data/v2tag" target="_blank">标签 Tag</a>。
 * @category Data
 * @demo
  import TagGroup from 'src/common/components/TagGroup/index';

  <TagGroup size="small" :tags="expenseTags"/>
 */
const Component: FC<{
  /** 标签类型，默认使用 tags 内的标签；如果没有，则使用 color */
  color?: string,
  /** 标签数组，Tag 标签属性基于 <a href="https://reactpc.lanhanba.net/components/Data/v2tag" target="_blank">标签 Tag</a>。
    <br/>
    TagProps: { label: 标签文本, tip: tooltip 提示文本 }
   */
  tags: TagProps[],
  /** 是否换行显示 */
  wrap?: Boolean,
  /** 需要超出显示省略号 */
  needEllipsis?: Boolean,
  className?: string,
}> = ({ color, tags = [], wrap = true, needEllipsis = false, className }) => {

  const renderTag = (item) => {
    if (item.img) {
      return <img src={item.img} className={styles.imgTag} style={{ width: item.imgWidth, height: item.imgHeight || '21px' }} />;
    }
    // 商圈中的自定义标签
    if (item.isCustomColor && item.color) {
      return <div
        className={styles.labelItemCon}
        style={{
          color: item.color || '#666',
          // borderColor: hexToRgba(item.groupColor || '#666', 0.5),
          borderColor: item.color || '#666',
        }}
      >
        {item.label}
      </div>;
    }

    return <V2Tag
      color={item.color || color}
      icon={item.icon}
      onClick={item.onClick}
      className={item.className}
      style={item.style}
      tooltipConfig={item.tooltipConfig}
    >{item.label}</V2Tag>;
  };

  return (Array.isArray(tags) && !!tags.length ? <div className={cs(styles.tags, wrap && styles.wrap, needEllipsis && styles.needEllipsis, className)}>
    {tags.map((item, index) => (isNotEmpty(item.tip) ? <Tooltip key={index} placement='top' title={item.tip}>
      <span>{renderTag(item)}</span>
    </Tooltip> : <Fragment key={index}>{renderTag(item)}</Fragment>))}
  </div> : <></>);
};

export default Component;
